import { Link } from '@tanstack/react-router'
import { Cog } from 'lucide-react'
import { Menu, MenuRow, menuItem } from './Menu'

/**
 * The cog: every page the Admin Site has that is not a screen in its own right.
 *
 * A few entries today. The Admin Site's launch set is seven areas -- Questions, Mocks, Exams,
 * Accounts, Money, Guards, System (admin-site.md) -- and the ones that belong behind a cog rather
 * than in a navigation bar are not settled yet, so this lists what exists and grows a line at a
 * time. It is a list from the first item on purpose: a cog that navigated straight to the only
 * page would have to become a menu the moment there were two, and every Admin's muscle memory
 * would break on the day it did.
 */
export function PagesMenu() {
  return (
    <Menu label="Settings" icon={<Cog aria-hidden="true" />}>
      <MenuRow>
        <Link to="/settings/brands" className={menuItem}>Brands</Link>
      </MenuRow>
      <MenuRow>
        <Link to="/settings/exams" className={menuItem}>Exam Settings</Link>
      </MenuRow>
      <MenuRow>
        <Link to="/settings/llm" className={menuItem}>
          LLM Settings
        </Link>
      </MenuRow>
      <MenuRow>
        <Link to="/settings/session" className={menuItem}>
          Session
        </Link>
      </MenuRow>
    </Menu>
  )
}
